import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange, gameCount }) => {
  const getCategoryIcon = (category) => {
    const iconMap = {
      'all': 'Grid3X3',
      'live-casino': 'Video',
      'sports-betting': 'Trophy',
      'slots': 'Zap',
      'lottery': 'Ticket',
      'card-games': 'Spade',
      'roulette': 'Circle',
      'cricket': 'Target'
    };
    return iconMap?.[category] || 'GamepadIcon';
  };

  return (
    <div className="bg-card rounded-card border border-border p-4 shadow-subtle">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-lg text-text-primary">
          Game Categories
        </h3>
        <div className="flex items-center space-x-2 text-sm text-text-secondary">
          <Icon name="Filter" size={16} />
          <span>{gameCount} games</span>
        </div>
      </div>
      {/* Desktop Categories */}
      <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-3">
        {categories?.map((category) => (
          <Button
            key={category?.id}
            variant={activeCategory === category?.id ? "default" : "outline"}
            size="sm"
            onClick={() => onCategoryChange(category?.id)}
            iconName={getCategoryIcon(category?.id)}
            iconPosition="left"
            className={`justify-start ${
              activeCategory === category?.id 
                ? 'bg-gradient-royal shadow-royal' 
                : 'hover:bg-muted hover:border-primary'
            }`}
          >
            <div className="flex items-center justify-between w-full">
              <span>{category?.name}</span>
              <span className="text-xs opacity-70">({category?.count})</span>
            </div>
          </Button>
        ))}
      </div>
      {/* Mobile Categories - Horizontal Scroll */}
      <div className="md:hidden">
        <div className="flex space-x-2 overflow-x-auto pb-2 scrollbar-hide">
          {categories?.map((category) => (
            <Button
              key={category?.id}
              variant={activeCategory === category?.id ? "default" : "outline"}
              size="sm"
              onClick={() => onCategoryChange(category?.id)}
              iconName={getCategoryIcon(category?.id)}
              iconPosition="left"
              className={`whitespace-nowrap ${
                activeCategory === category?.id 
                  ? 'bg-gradient-royal shadow-royal' 
                  : 'hover:bg-muted'
              }`}
            >
              {category?.name} ({category?.count})
            </Button>
          ))}
        </div>
      </div>
      {/* Quick Filters */}
      <div className="mt-4 pt-4 border-t border-border">
        <p className="text-sm font-medium text-text-primary mb-2">Quick Filters</p>
        <div className="flex flex-wrap gap-2">
          <button className="inline-flex items-center space-x-1 px-3 py-1 rounded-button bg-muted hover:bg-primary hover:text-primary-foreground text-sm transition-royal">
            <Icon name="Zap" size={14} />
            <span>Live Games</span>
          </button>
          <button className="inline-flex items-center space-x-1 px-3 py-1 rounded-button bg-muted hover:bg-primary hover:text-primary-foreground text-sm transition-royal">
            <Icon name="TrendingUp" size={14} />
            <span>Popular</span>
          </button>
          <button className="inline-flex items-center space-x-1 px-3 py-1 rounded-button bg-muted hover:bg-primary hover:text-primary-foreground text-sm transition-royal">
            <Icon name="IndianRupee" size={14} />
            <span>Low Stakes</span>
          </button>
          <button className="inline-flex items-center space-x-1 px-3 py-1 rounded-button bg-muted hover:bg-primary hover:text-primary-foreground text-sm transition-royal">
            <Icon name="Crown" size={14} />
            <span>VIP Tables</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoryFilter;